import React from 'react';
import { Section } from '@layout';
import { CardsWrapper } from '@components/Card';
import Media from '@components/Media';
import { H2 } from '@heading';
import { Button, ButtonsWrapper } from '@input';
import styles from './Videos.module.scss';
import jimmyKimmelThumb from './jimmy-kimmel.jpg';
import nacwThumb from './nacw.jpg';
import outreachThumb from './outreach.jpg';

export default function Videos() {
  return (
    <Section
      className={styles.wrapper}
      fullWidth
      isDark
    >
      <div className={styles.top}>
        <H2>In the media</H2>
      </div>
      <CardsWrapper className={styles.videos}>
        <Media
          src="//www.youtube.com/watch?v=9UCdFbyL8y0"
          thumbnail={jimmyKimmelThumb}
          className={styles.video}
          title="Jimmy Kimmel Live"
        >
          Aradhna discusses climate change on Jimmy Kimmel Live
        </Media>

        <Media
          src="//www.youtube.com/watch?v=bO5mCb7MKAM"
          thumbnail={nacwThumb}
          className={styles.video}
          title="NACW 2019"
        >
          Aradhna's presentation at the North American Carbon World
          conference
        </Media>

        <Media
          src="//www.youtube.com/watch?v=rKi5JqBC68s"
          thumbnail={outreachThumb}
          className={styles.video}
          title="Community Outreach"
        >
          Students from Santa Monica college learn from Aradhna's research
          team
        </Media>
      </CardsWrapper>
      <ButtonsWrapper>
        <Button
          theme="white"
          to="/about/videos"
        >
          Watch more from Aradhna
        </Button>
        <Button
          theme="white"
          to="/about/keynotes-and-lectures"
        >
          View Keynotes &amp; Lectures
        </Button>
      </ButtonsWrapper>
    </Section>
  );
}
